export const ForecastMaterialsSliceConstants = {
  GetForecastMaterials: 'getForecastMaterials',
  GetForecastMaterialInfo: 'getForecastMaterialInfo',
  GetCloudStorageFiles: 'getCloudStorageFiles',
};
